module.exports = __webpack_public_path__ + "img/adhibition.7241e703.png";